
import HelperEnv from '../helpers/HelperEnv';
import {
  SETTING_SET_DEVELOPPER_VIEW, SETTING_SET_VIEW_FINANCE_FILE, 
  SETTING_SET_PERIMETER_FILTER, SETTING_SET_NETWORK_ZONE, SETTING_SET_VIEW_TEST_CALCULATOR, SETTING_SET_ZINDEX,
  SETTING_SET_AMOUNT_NATURE, SETTING_SET_VEH_DESC_TYPE, CONTEXT_SET_CUSTOMER, SETTING_SET_PROCESS, SETTING_SET_FINANCEFILE_PROPS,
  SETTING_SET_LANGUAGE, SETTING_SET_VEHICLE_EXAMPLES, SETTING_SET_WIDGET_TYPE, SETTING_SET_FINFILE_RESOURCE
} from '../actions/actionsAppTest'

const queryParameters = new URLSearchParams(window.location.search)
const queryParameterDevView  = queryParameters.get("dev") && queryParameters.get("dev") === "1" ? true : false;
const queryParameterAutomationInput  = queryParameters.get("autoinput") && queryParameters.get("autoinput") === "1" ? true : false;

export const initialStateSettings = {
  amountNature: 'TC', isAmountNatureSet: false, vehDescType: 'MANUFACTURER', process: 'summary',
  isOpen: false, isDevelopperView: queryParameterDevView, isTestCalculator: false, isFinanceFile: false, isAutomationInput: queryParameterAutomationInput,
  perimeterFilter: 'SFS', networkZone: HelperEnv.getEnvNetworkZoneDefault(), finfileResource: 'FINFILE', widgetType: 'WIDBPF'
};

export function settings(state, action) {
  switch (action.type) {
    case SETTING_SET_DEVELOPPER_VIEW: {
      return { ...state, isDevelopperView: action.payload.isDevelopperView };
    }
    case SETTING_SET_VIEW_FINANCE_FILE:
      return { ...state, isFinanceFile: action.payload.isFinanceFile }; 
    case SETTING_SET_NETWORK_ZONE:
      return { ...state, networkZone: action.payload.networkZone };
    case SETTING_SET_FINFILE_RESOURCE:
      return { ...state, finfileResource: action.payload.finfileResource };
    case SETTING_SET_VIEW_TEST_CALCULATOR:
      return { ...state, isTestCalculator: action.payload.isTestCalculator };
    case SETTING_SET_FINANCEFILE_PROPS:
      if (action.payload.isFinanceFile != null) {
        return { ...state, isFinanceFile: action.payload.isFinanceFile };
      } else {
        return state;
      }
    case SETTING_SET_AMOUNT_NATURE:
      return { ...state, amountNature: action.payload.amountNature, isAmountNatureSet: true };
    case SETTING_SET_VEH_DESC_TYPE:
      return { ...state, vehDescType: action.payload.vehDescType };
    case CONTEXT_SET_CUSTOMER:
      if (!state.isAmountNatureSet && action.payload.context != null && action.payload.context.customer != null && action.payload.context.customer.clientType != null) {
        return { ...state, amountNature: action.payload.context.customer.clientType === 'E' ? 'HT' : 'TC' };
      }
      return state;
    case SETTING_SET_PROCESS:
      return { ...state, process: action.payload.process };
    case SETTING_SET_LANGUAGE:
      var actualLanguage = action.payload.language === 'xx' ? action.payload.contextLanguage : action.payload.language;
      return { ...state, language: action.payload.language, actualLanguage: actualLanguage };
    case SETTING_SET_VEHICLE_EXAMPLES:
      return { ...state, vehicleExamples: action.payload.vehicleExamples };
    case SETTING_SET_PERIMETER_FILTER:
      return { ...state, perimeterFilter: action.payload.perimeterFilter };
    case SETTING_SET_WIDGET_TYPE:
      return { ...state, widgetType: action.payload.widgetType };
    case SETTING_SET_ZINDEX:
      return { ...state, zindex: action.payload.zindex };
    default:
      return state
  }
}
